// Marketing's location selection is the app-wide one now (the header
// Location picker, multiLocation/viewingSites.js): Home, the Calendar,
// Performance and Campaigns show the same locations as Finance. Kept as a
// module so marketing's imports don't change.
import { useViewingSites, salonIdsParam, isRemote, _reset } from '../../../../multiLocation/viewingSites'

export { salonIdsParam, isRemote, _reset }
export const useMarketingSites = useViewingSites
